import { RequisitionPerformanceReportComponent } from './requisition-performance-report.component';
import { RequisitionPerformanceReportService } from './requisition-performance-report.service';
agGrid.initialiseAgGridWithAngular1(angular);
export const RequisitionPerformanceReportModule = angular
    .module('requisitionPerformanceReportModule', ['agGrid'])
    .component(RequisitionPerformanceReportComponent.selector, RequisitionPerformanceReportComponent.component)
    .service('requisitionPerformanceReportService', RequisitionPerformanceReportService)
    .name;
//# sourceMappingURL=requisition-performance-report.module.js.map